<template>
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line :icon="data.icon" :statistic="data.total" :statisticTitle="data.title" :chartData="data.chartData" :type="data.chart_type" :color="data.color"></statistics-card-line>
    </div>
</template>

<script>
    import StatisticsCardLine from "../statistics-cards/StatisticsCardLine";

    export default {
        name: "card-line",
        props: {
            data: Object
        },
        components: {
            StatisticsCardLine
        }
    };
</script>
